<template>
  <el-dialog
    :title="title"
    v-model="showView"
    width="340px"
    :before-close="handleClose"
    :show-close="false"
  >

      <el-input
        autocomplete="off"
        name="inputVal"
        v-model="inputVal"
        placeholder="请让客户按密码器输入"
        style="max-width: 300px"
        @keyup.enter="clickDo"
        type="password"
        clearable
         maxlength="20"
      ></el-input>
      <p class="base_color mt-3 select-none">注意：请让客户按密码器输入</p>

    <template #footer>
      <span class="dialog-footer flex justify-end items-center">

         <el-button @click="clickDo" type="primary" >确 定</el-button>
         <el-button @click="doCloseEvent">取 消</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
export default {

  name: 'ScanCard',
  props: {
    title: {
      type: String,
      default: '请输入支付密码'
    },
    showView: Boolean
  },
  setup (props, { emit }) {
    const inputVal = ref('')
    const clickDo = () => {
      if (inputVal.value.trim() == '') {
        ElMessage({
          showClose: true,
          message: '请让客户按密码器输入支付密码',
          type: 'error'
        })
        document.getElementsByName('inputVal')[0].focus()
        return
      }
      emit('confirmEvent', inputVal.value)
      inputVal.value = ''
    }
    const handleClose = () => {}
    const doCloseEvent = () => {
      inputVal.value = ''
      emit('closeEvent')
    }
    watch(
      () => props.showView,
      (newVal, oldVal) => {
        if (newVal) {
          setTimeout(() => {
            document.getElementsByName('inputVal')[0].focus()
          }, 100)
        }
      }
    )

    return {
      clickDo,
      inputVal,
      handleClose,
      doCloseEvent
    }
  }
}
</script>
